<template>
    <v-container class="grey lighten-5" fluid>
        <v-row align="center" style="height: 600px;">
            <v-col md="4" offset-md="4" class="login-container">
                <v-card class="pa-5" shaped>
                    <div class="d-flex justify-center">
                        <v-img src="../assets/tp-logo.png" max-width="80"></v-img>
                    </div>
                    <v-form ref="form" lazy-validation @submit="onSubmit">
                        <v-text-field
                            v-model="form.username"
                            :rules="[rules.required]"
                            label="Username"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="form.password"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show ? 'text' : 'password'"
                            @click:append="show = !show"
                            :rules="[rules.required]"
                            label="Password"
                            required
                        ></v-text-field>

                        <v-row>
                            <v-col md="6" class="caption">
                                <router-link :to="{ name: 'TestAccountCreator'}">Create Test Merchant Account</router-link>
                                <div class="login-error">
                                    <span v-if="loginError" class="red--text">Incorrect login credentials</span>
                                </div>
                            </v-col>
                            <v-col md="6" class="text-right">
                                <v-btn type="submit" color="info">Login</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        beforeMount() {
            console.log(location.hostname);
        },
        data () {
            return {
                loginForm: null,
                form: {
                    username: '',
                    password: ''
                },
                show: false,
                rules: {
                    required: v => !!v || 'Required.',
                }
            }
        },
        computed: {
            loginError() {
                return this.$store.state.error;
            }
        },
        methods: {
            onSubmit(e) {
                e.preventDefault();
                if(this.$refs.form.validate()) {
                    this.error = this.$store.dispatch('login', this.form);
                }
            }
        }
    }
</script>

<style>
    .login-error {
        height: 18px;
    }
</style>